// extracted by mini-css-extract-plugin
export var cancelButton = "_nq-5";
export var content = "_nq-3";
export var createButton = "_nq-6";
export var drawerContainer = "_nq-0";
export var footer = "_nq-2";
export var header = "_nq-1";
export var orderFormColumn = "_nq-4";